import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="h-screen flex items-center justify-center bg-[#F5F5F5]">
        <div className="text-[#0D2B5E] font-mono tracking-widest text-sm">LOADING SUPPLAR…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
